import axios from 'axios'

import { ReleaseNoteModel } from '@/interfaces'

export const releaseNotesClient = {
  QUERY_KEY: ['releaseNotes'],
  getReleaseNotes: () =>
    axios.get<ReleaseNoteModel[]>('/api/releaseNotes').then(x => x.data)
}
